<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长管理</el-breadcrumb-item>
        <el-breadcrumb-item>学长管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学长管理</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleSeniorCreate">添加学长</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="年份"
                      prop="year">
          <el-select v-model="recruit_years"
                     placeholder="请选择"
                     clearable
                     multiple
                     @input="fetchSeniorList(true)">
            <el-option v-for="(item, index) in filter.yearList"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学长"
                      prop="keyword">
          <el-input v-model="query.keyword"
                    placeholder="输入姓名/手机号"
                    @input="fetchSeniorList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="昵称"
                      prop="comb_keyword">
          <el-input v-model="query.comb_keyword"
                    placeholder="输入学长昵称"
                    @input="fetchSeniorList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="院校"
                      prop="college">
          <el-input v-model="query.college"
                    @input="fetchSeniorList(true)"
                    placeholder="输入院校名称/代码"
                    clearable></el-input>
        </el-form-item>
        <!--<el-form-item
          label="学院"
          prop="major"
        >
          <el-input
            v-model="query.academy"
            placeholder="输入学院名称/代码"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="专业"
                      prop="major">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.major"
                    placeholder="输入专业名称/代码"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="学院">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.academy_keyword"
                    placeholder="输入学院名称/代码"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="科目">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.subject_keyword"
                    clearable
                    placeholder="输入科目名称/代码"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     @change="fetchSeniorList(true)">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="累计收益大于"
                      prop="user_total_profit_amount_low ">
          <el-input @input="searchSetTimeout"
                    v-model="query.user_total_profit_amount_low"
                    placeholder="输入数字"
                    oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="邀请人"
                      prop="status">
          <el-select v-model="query.invite_info"
                     placeholder="请选择"
                     @input="fetchSeniorList(true)">
            <el-option v-for="(item, index) in invite_options"
                       :key="index"
                       :label="item.invite_info"
                       :value="item.invite_info">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="推荐开关"
                      prop="status">
          <el-select v-model="query.auto_recommend_status"
                     placeholder="请选择"
                     @input="fetchSeniorList(true)">
            <el-option v-for="(item, index) in filter.recommed"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="招呼语关键词"
                      prop="default_greet_message_keyword">
          <el-input @input="fetchSeniorList(true)"
                    v-model="query.default_greet_message_keyword"
                    clearable
                    placeholder="请输入关键字"></el-input>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">查找结果</h3>
        <el-form label-width="100px"
                 size="small"
                 style="margin-bottom: 0px">
          <el-form-item label="邀请人数排序">
            <el-switch v-model="query.order_by_type"
                       :active-value="1"
                       :inactive-value="0"
                       @change="fetchSeniorList(true)">
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%"
                  v-loading="loading">
          <el-table-column prop="id"
                           label="用户ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="realname"
                           label="姓名/手机号"
                           min-width="180"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.realname }}/{{ scope.row.mobile }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="recruit_year"
                           label="年份"
                           min-width="90"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.recruit_year }}年</span>
            </template>
          </el-table-column>
          <el-table-column label="院校"
                           min-width="120"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.recruit_college_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="学院"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.recruit_academy_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="专业"
                           min-width="180"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>({{ scope.row.recruit_major_code || "-" }}){{
                  scope.row.recruit_major_name || "-"
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="录取方向"
                           min-width="180"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                  scope.row.recruit_direction_name || ""
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="重点合作"
                           min-width="100"
                           align="center">
            <template slot-scope="scope">
              <span style="color:#409eff;cursor: pointer;"
                    @click="updateStatus(scope.row)">{{
                  scope.row.emphasis_cooperate_status==1?'是':'否' 
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="文章数量"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.statistic_senior_article_count}}篇
            </template>
          </el-table-column>
          <el-table-column label="课程数量"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.statistic_senior_course_count }}个
            </template>
          </el-table-column>
          <el-table-column label="资料数量"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.statistic_senior_read_count  }}个
            </template>
          </el-table-column>
          <el-table-column label="累计收益"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.user_total_profit_amount }}元
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "正常" : "禁用" }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="优势补充"
                           width="260"
                           align="center"
                           prop="additional"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                scope.row.additional ? scope.row.additional : "无"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="成绩截图"
                           align="center">
            <template slot-scope="scope">
              <el-image v-if="scope.row.recruit_certify_img"
                        style="width: 60px; height: 60px"
                        :src="scope.row.recruit_certify_img"
                        :preview-src-list="[scope.row.recruit_certify_img]">
              </el-image>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="课时费"
                           width="100"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.fee_amount }}元/小时</span>
            </template>
          </el-table-column>
          <el-table-column label="描述"
                           width="260"
                           align="center"
                           prop="description">
            <template slot-scope="scope">
              <span>{{
                scope.row.description ? scope.row.description : "无"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="invite_info"
                           label="邀请人"
                           width="100"
                           align="center">
          </el-table-column>
          <el-table-column label="申请入驻时间"
                           align="center"
                           width="150">
            <template slot-scope="scope">
              {{
                scope.row.apply_log_create_time
                  ? $moment(scope.row.apply_log_create_time).format(
                      "YYYY-MM-DD HH:mm"
                    )
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="审核通过时间"
                           align="center"
                           width="150">
            <template slot-scope="scope">
              {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="200"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToSeniorEdit(scope.row, scope.$index)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToPersonal(scope.row)">主页</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToSeniorDetail(scope.row, scope.$index)">详情</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="deleteItem(scope.row)">删除</el-link>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link"> ... </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom: 6px"><span @click="handleToSeniorEdit(scope.row, scope.$index)"
                          style="font-size: 16px; color: #409eff">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom: 6px"><span @click="handleToSeniorDetail(scope.row, scope.$index)"
                          style="font-size: 16px; color: #409eff">
                      详情
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom: 6px"><span @click="deleteItem(scope.row)"
                          style="font-size: 16px; color: #f56c6c">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <SeniorCreate :visible="createDialog"
                  @close="createDialog = false"
                  @submit="fetchSeniorList"></SeniorCreate>
    <ApplyDialog :visible="applyDialogVisible"
                 :content="applyItem"
                 @submit="ApplyDialogSubmit"
                 @close="applyDialogVisible = false" />
    <Greeing :visible="serviceDialogVisible"
             :serviceDetail="serviceDetail"
             @submit="fetchSeniorList"
             @close="serviceDialogVisible = false"></Greeing>
    <UserSeniorMess :visible="seniorVisible"
                    :rowDetail="rowDetail"
                    @close="seniorClose()" />
    <DetailLookSync :isVisible="lookDetailVisible"
                    @close="lookDetailClose"
                    :rowDetail="rowDetail" />
    <el-dialog title="修改合作状态"
               :visible.sync="dialogVisible"
               width="400px"
               :close-on-click-modal="false"
               @close="dialogVisible=false">
      <el-form label-width="80px">
        <el-form-item label="合作状态">
          <el-radio-group v-model="selectedValue">
            <el-radio :label="option.value"
                      v-for="option in options"
                      :key="option.value">
              {{ option.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible=false">取 消</el-button>
        <el-button type="primary"
                   @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { seniorList, seniorDestroy, seniorUpdate } from '@/api/senior'
import SeniorCreate from '@/components/dialog/senior/SeniorCreate'
import Greeing from '@/components/dialog/senior/sendGreeting'
import DetailLookSync from '@/components/dialog/DetailLookSync'
// ApplyDialog之前是学长申请页面的表格详情弹窗，现在成为学长管理页面的表格详情弹窗
import ApplyDialog from '@/components/dialog/senior/Apply'
import UserSeniorMess from '@/components/dialog/senior/userSeniorMess'
let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    SeniorCreate,
    ApplyDialog,
    Greeing,
    UserSeniorMess,
    DetailLookSync,
  },
  data() {
    return {
      options: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],
      selectedValue: 0,
      currid: null,
      dialogVisible: false,
      lookDetailVisible: false,
      seniorVisible: false,
      applyDialogVisible: false,
      serviceDialogVisible: false,
      applyItem: {},
      createDialog: false,
      editRow: {},
      rowDetail: {},
      serviceDetail: {},
      recruit_years: [],
      query: {
        is_statistic_senior: 1,
        keyword: '',
        status: '',
        college: '',
        major: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        // is_invite_list: 1,
      },
      pageTotal: 1000,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '正常', value: '1' },
          { label: '禁用', value: '0' },
        ],
        recommed: [
          { label: '是', value: '1' },
          { label: '否', value: '0' },
        ],
        yearList: [
          { label: '2019年', value: '2019' },
          { label: '2020年', value: '2020' },
          { label: '2021年', value: '2021' },
          { label: '2022年', value: '2022' },
          { label: '2023年', value: '2023' },
          { label: '2024年', value: '2024' },
          { label: '2025年', value: '2025' },
          { label: '2026年', value: '2026' },
          { label: '2027年', value: '2027' },
          { label: '2028年', value: '2028' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      loading: false,
      invite_options: [],
    }
  },
  created() {
    this.parseQuery()
    this.fetchSeniorList()
    this.inviterList()
  },
  methods: {
    //修改合作状态
    updateStatus(row) {
      this.currid = row.id
      this.selectedValue = row.emphasis_cooperate_status
      this.dialogVisible = true
    },
    handleConfirm() {
      seniorUpdate({
        id: this.currid,
        emphasis_cooperate_status: this.selectedValue,
      }).then((res) => {
        this.dialogVisible = false
        this.fetchSeniorList()
      })
    },
    lookDetailClose() {
      this.lookDetailVisible = false
    },
    seniorClose() {
      this.seniorVisible = false
    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchSeniorList(true)
      }, TimerTime)
    },
    handleToPersonal(row) {
      this.lookDetailVisible = true
      this.rowDetail = row
    },

    // 邀请人
    inviterList() {
      let data = { ...this.query }
      data.is_invite_list = 1
      data.pageIndex = 1
      data.pageSize = 1
      seniorList(data).then((res) => {
        this.invite_options = res.invite_list
      })
    },
    // 用户列表
    fetchSeniorList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      this.query.is_get_chat = 1
      if (this.recruit_years.length > 0) {
        this.query.recruit_years = this.recruit_years.join(',')
      } else {
        this.query.recruit_years = ''
      }

      console.log('this.query', this.query)
      seniorList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count || 0
        // this.invite_options = res.invite_list;
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchSeniorList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchSeniorList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchSeniorList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchSeniorList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: '正常',
        0: '禁用',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 学长详情
    handleToSeniorDetail(row) {
      this.applyItem = JSON.parse(JSON.stringify(row))
      this.applyDialogVisible = !this.applyDialogVisible
    },

    handleToSeniorEdit(row) {
      this.rowDetail = row
      this.seniorVisible = true
      // this.$router.push(`/senior/list/detail/${row.uid}`)
    },
    handleToSeniorService(row) {
      this.serviceDetail = row
      this.serviceDialogVisible = true
    },
    // 学长创建
    handleSeniorCreate() {
      this.createDialog = true
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    // 详情弹窗关闭
    ApplyDialogSubmit() {
      this.applyDialogVisible = false
      this.fetchSeniorList()
    },
    serviceDialogSubmit() {},
    deleteItem(item) {
      this.$confirm('确定要删除此条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          seniorDestroy({ id: item.id }).then((res) => {
            this.$nextTick(() => {
              this.fetchSeniorList()
            })
          })
        })
        .catch(() => {
          this.$notify.error({
            title: '提示',
            message: '已取消删除',
          })
        })
    },
  },
}
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .table-header {
      margin: 8px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  margin: 0px 8px;
  font-size: 12px;
}
</style>
